import PartsTable from 'app/[lang]/[esite]/(core)/parts-diagram/_components/parts-layout/parts-table';
import PartsOverview from 'components/parts-overview';
import { LineItem, PartDetailsAndSchematicResponse } from 'types/parts-diagram';

interface PartsTableWrapperProps {
  partDetailsAndSchematicsData: PartDetailsAndSchematicResponse;
  handlePartView: (lineItem: LineItem) => void;
  fromProductPage?: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}

const PartsTableWrapper = ({
  partDetailsAndSchematicsData,
  handlePartView,
  fromProductPage = false,
  isRTL = false,
  currencyLdFeatureFlag = false
}: PartsTableWrapperProps) => {
  return (
    <>
      <div className="d-none d-lg-block">
        <PartsTable
          partDetailsAndSchematicsData={partDetailsAndSchematicsData}
          handlePartView={handlePartView}
          shouldHideBtn
          fromProductPage={fromProductPage}
          isRTL={isRTL}
          currencyLdFeatureFlag={currencyLdFeatureFlag}
        />
      </div>
      <div className="d-block d-lg-none">
        <PartsOverview
          partDetailsAndSchematicsData={partDetailsAndSchematicsData}
          handlePartView={handlePartView}
          shouldHideBtn
          fromProductPage={fromProductPage}
          isRTL={isRTL}
          currencyLdFeatureFlag={currencyLdFeatureFlag}
        />
      </div>
    </>
  );
};

export default PartsTableWrapper;
